export default __webpack_public_path__ + "static/media/07.5b97f2cb.jpg";